




















































import { Component, Vue, Prop } from 'vue-property-decorator';
import UpcomingNotification from '@/components/NewsFeed/UpcomingNotification.vue';
import EventFeedView from '@/components/NewsFeed/EventFeedView.vue';
import PersonData from '@/ts/PersonData';
import DashboardNotification from '@/ts/instances/notifications/DashboardNotification';
import { DashboardTabs} from '@/ts/interfaces/TabInterfaces';
import { Mutations, Actions, Views, ViewModes } from '@/ts/store/Constants';
import { Swiper, SwiperSlide } from 'vue-awesome-swiper';
import BroadcastCard from '@/components/NewsFeed/Components/BroadcastCard.vue';
import EventCard from '@/components/NewsFeed/Components/EventCard.vue';
import InfiniteScroll from '@/components/Scrolls/InfiniteScroll.vue';
import { setScroll } from '@/plugins/save-position';

@Component({
    components: {
        EventFeedView,
        Swiper,
        SwiperSlide,
        UpcomingNotification,
        BroadcastCard,
        EventCard,
        InfiniteScroll,
    },
    data() {
        return {
            swiperOption: {
                direction: 'horizontal',
                slidesPerView: 'auto',
                freeMode: false,
                mousewheel: true,
            },
        };
    },
})
export default class MobileNewsFeed extends Vue {
    @Prop() public containerId: string;

    public tabs: DashboardTabs[] = [
        {
            label: this.$t('general.all', 'All'),
            value: 'all',
            filter: ['event', 'information'],
        },
        {
            label: this.$t('general.events', 'Events'),
            value: 'events',
            filter: ['event'],
        },
        {
            label: this.$t('general.general-information', 'General information'),
            value: 'broadcasts',
            filter: ['information'],
        },
    ];

    constructor() {
        super();
    }

    get user(): PersonData {
        return this.$store.getters['User/getUser'];
    }

    get activeTab(): string {
        return this.$store.getters['TenantNotifications/getDashboardActiveTab'];
    }

    get page(): number {
        return this.$store.getters['TenantNotifications/getDashboardPage'];
    }

    get lastPage(): number {
        return this.$store.getters['TenantNotifications/getDashboardLastPage'];
    }

    get activeFilter(): DashboardTabs {
        return this.tabs.find((tab: DashboardTabs) => tab.value === this.activeTab);
    }

    get notifications(): DashboardNotification[] {
        return this.$store.getters['TenantNotifications/getDashboardNotifications'];
    }

    get sortedNotifications(): DashboardNotification[] {
        return this.notifications.sort((a, b) => {
            if (a.dateSortingCriterion > b.dateSortingCriterion) {
                return 1;
            }

            if (a.dateSortingCriterion < b.dateSortingCriterion) {
                return -1;
            }

            return 0;
        });
    }

    public refresh(done: any) {
        this.$store.commit(Mutations.SET_DASHBOARD_PAGE, 1);

        this.$store.dispatch(Actions.FETCH_TENANT_UPCOMING_EVENTS);
        this.$store.dispatch(Actions.FETCH_DASHBOARD_NOTIFICATIONS, {
            page: 1,
            type: this.activeFilter.filter,
            hardReload: true,
        }).then(() => {
            done();
        });
    }

    public changeDashboardTab(tabIndex: number) {
        const swiper = this.$refs.filters as any;
        const slide  = this.tabs[tabIndex];

        this.$store.commit(Mutations.SET_DASHBOARD_PAGE, 1);
        this.$store.commit(Mutations.SET_DASHBOARD_PAGE_ACTIVE_FILTER, slide.value);

        swiper.$swiper.slideTo(tabIndex, 1000, false);

        this.$store.dispatch(Actions.FETCH_DASHBOARD_NOTIFICATIONS, {
            page: 1,
            type: this.activeFilter.filter,
            hardReload: true,
        });
    }

    public handleScroll({ target: { scrollTop, clientHeight, scrollHeight }}: any) {
        if (scrollTop + clientHeight >= scrollHeight) {
            if (this.lastPage === this.page) {
                return;
            }

            this.$store.dispatch(Actions.FETCH_DASHBOARD_NOTIFICATIONS, {
                page: this.page,
                type: this.activeFilter.filter,
            });
        }
    }

    public created() {
        this.$store.commit(Mutations.SET_VIEW, {
            view: Views.Notifications,
            viewMode: ViewModes.Notifications.All,
        });
    }

    public mounted() {
        setScroll(this.containerId, 'getTenantAppPagePosition');

        this.$store.dispatch(Actions.INITIALIZE_TENANT_LOG_SOCKET, this);
        this.$store.dispatch(Actions.FETCH_TENANTS_NOTIFICATIONS_UNREAD_COUNT);
        this.$store.dispatch(Actions.FETCH_TENANT_UPCOMING_EVENTS);

        if (!this.notifications.length) {
            this.$store.dispatch(Actions.FETCH_DASHBOARD_NOTIFICATIONS, {
                page: 1,
                type: this.activeFilter.filter,
                hardReload: true,
            });
        }
    }
}
